import MainLayout from '../layouts/main';
import LastReviewContainer from './container';

function LastReviewPage() {
  return (
    <MainLayout withFooter>
      <LastReviewContainer />
    </MainLayout>
  );
}

export default LastReviewPage;
